import React, { useState } from "react";
import styled from "styled-components";
import { Table, Input, Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import {
  useQueryParam,
  NumberParam,
  withDefault,
} from "use-query-params";

import { LIMIT_PAGE } from "constants/index";

import { TAXE_COLUMNS } from "./constants";
import { taxes } from "./mock";

const Container = styled.div`
  padding: 12px;
`;

const StyledRow = styled(Row)`
  padding-bottom: 12px;
`;

const FlexCol = styled(Col)`
  display: flex;
  justify-content: space-between;
`;

const { Search } = Input;

const Taxes = () => {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const [page, setPage] = useQueryParam("page", withDefault(NumberParam, 1));

  const taxesData = taxes.filter(({ name }) =>
    `${name}`.includes(search.trim()));

  return (
    <Container>
      <StyledRow>
        <FlexCol>
          <Col span={4}>
            <Search
              placeholder={t("QuickSearch")}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Col>
        </FlexCol>
      </StyledRow>
      <Table
        pagination={{
          current: page,
          onChange: setPage,
          pageSize: LIMIT_PAGE,
        }}
        rowKey="id"
        columns={TAXE_COLUMNS}
        dataSource={taxesData}
      />
    </Container>
  );
};

export default Taxes;
